import { MatSelect } from '@angular/material/select';

export function applyMonkeyPatching() {
    fixMatSelectStackOverflow();
    fixPdfWorkerSrc();
}

function fixMatSelectStackOverflow() {
    (MatSelect.prototype as any)._onSelect = function (option: any, isUserInput: any) {
        const wasSelected = this._selectionModel.isSelected(option);
        if (option.value === null && !this._multiple) {
            option.deselect();
            this._selectionModel.clear();
            this._propagateChanges(option.value);
        } else {
            // This `if (wasSelected !== option.selected) {` is added by monkey patching to fix a bug were this method called itself resulsively
            // reference to the bug https://github.com/angular/components/issues/12504
            // It was copied from https://github.com/angular/components/blob/23dfbbb238b29fb3cc2bda680186cf0a9b8c40f1/src/material/select/select.ts#L908
            // By comparing it to previous versions where the bug existed
            // See the current version of _onSelect at:
            // node_modules/@angular/material/esm5/select.es5.js:1262
            // TODO: Remove this when updating angular material.
            if (wasSelected !== option.selected) {
                option.selected ? this._selectionModel.select(option) : this._selectionModel.deselect(option);
            }
            if (isUserInput) {
                this._keyManager.setActiveItem(option);
            }
            if (this.multiple) {
                this._sortValues();
                if (isUserInput) {
                    this.focus();
                }
            }
        }
        if (wasSelected !== this._selectionModel.isSelected(option)) {
            this._propagateChanges();
        }
        this.stateChanges.next();
    };
}

function fixPdfWorkerSrc() {
    /**
     * The only way to change the work used by ng2-pdf-viewer is by monkey patching the window...
     * https://github.com/VadimDez/ng2-pdf-viewer#set-custom-path-to-the-worker
     */
    /**
     * Disabling this while this issue is not resolved and publish (maybe 19.1.0 ?)
     * https://github.com/angular/angular-cli/issues/27425
     */
    // (<any>window).pdfWorkerSrc = 'assets/pdf.worker.min.mjs';
}
